import type { RevenueThisMonthDTO } from "../models/revenueThisMonthDto";
import type { RevenueThisMonthEntity } from "../../domain/entities/RevenueThisMonthEntity";

export function revenueThisMonthDtoToEntity(
  dto: RevenueThisMonthDTO
): RevenueThisMonthEntity {
  return {
    revenueThisWeek: Number(dto.revenueThisWeek) || 0,
    revenueThisMonth: Number(dto.revenueThisMonth) || 0,
    subTotalThisWeek: Number(dto.subTotalThisWeek) || 0,
    taxTotalThisWeek: Number(dto.taxTotalThisWeek) || 0,
    subTotalThisMonth: Number(dto.subTotalThisMonth) || 0,
    taxTotalThisMonth: Number(dto.taxTotalThisMonth) || 0,
    monthLabel: String(dto.monthLabel ?? ""),
    weekNumberInMonth: Number(dto.weekNumberInMonth) || 1,
    totalWeeksInMonth: Number(dto.totalWeeksInMonth) || 1,
    weekStart: String(dto.weekStart ?? ""),
    weekEnd: String(dto.weekEnd ?? ""),
  };
}
